import React from 'react';
import { Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import {
  ProgressContainer,
  StepWrapper,
  StepConnector,
  StepNumberAvatar,
  StepLabel
} from './ProgressIndicator.styles';

export default function ProgressIndicator({ currentPage, stepTitles }) {
    return (
        <ProgressContainer>
            <Stack direction="row" spacing={0} alignItems="flex-start" sx={{ width: '100%', position: 'relative', justifyContent: 'space-between' }}>
                {Array.isArray(stepTitles) && stepTitles.map((step, index) => {
                    const stepNumber = index + 1;
                    const isActive = currentPage === stepNumber;
                    const isCompleted = currentPage > stepNumber;

                    return (
                        <React.Fragment key={index}>
                            {index > 0 && (
                                <StepConnector completed={isCompleted || isActive} />
                            )}
                            <StepWrapper>
                                <StepNumberAvatar active={isActive} completed={isCompleted}>
                                    {isCompleted ? <CheckIcon fontSize="small" /> : stepNumber}
                                </StepNumberAvatar>
                                <StepLabel variant="caption" active={isActive} completed={isCompleted}>
                                    {step}
                                </StepLabel>
                            </StepWrapper>
                        </React.Fragment>
                    );
                })}
            </Stack>
        </ProgressContainer>
    );
}